// const pre=`http://localhost:2929/`;
// const pre=`http://5.189.166.187:5551/GamePortalBackendNewLiveDemo/`;
const pre=`https://www.demobackendportal.nigergames.com/`;
const getGamesApi=`${pre}sendGames`;
export{getGamesApi};

// http://5.189.166.187:5551/GamePortalBackendNewLiveDemo/sendGames